export default [
    {
        logoId: 1,
        name: "Flecha Sagrada",
        levelsInfo: [
            {
                level: 1,
                cooldown: 1,
                mp: 40,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 63 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 1,
            },
            {
                level: 2,
                cooldown: 1,
                mp: 49,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 77 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 4,
            },
            {
                level: 3,
                cooldown: 1,
                mp: 65,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 103 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 8,
            },
            {
                level: 4,
                cooldown: 1,
                mp: 83,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 132 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 12,
            },
            {
                level: 5,
                cooldown: 1,
                mp: 104,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 165 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 16,
            },
            {
                level: 6,
                cooldown: 1,
                mp: 129,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 205 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 20,
            },
            {
                level: 7,
                cooldown: 1,
                mp: 156,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 248 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 24,
            },
            {
                level: 8,
                cooldown: 1,
                mp: 191,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 303 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 28,
            },
            {
                level: 9,
                cooldown: 1,
                mp: 231,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 366 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 32,
            },
            {
                level: 10,
                cooldown: 1,
                mp: 279,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 443 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 36,
            },
            {
                level: 11,
                cooldown: 1,
                mp: 337,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 535 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 40,
            },
            {
                level: 12,
                cooldown: 1,
                mp: 397,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 630 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 44,
            },
            {
                level: 13,
                cooldown: 1,
                mp: 467,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 744 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 48,
            },
            {
                level: 14,
                cooldown: 1,
                mp: 543,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 862 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 52,
            },
            {
                level: 15,
                cooldown: 1,
                mp: 630,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 1000 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 56,
            },
            {
                level: 16,
                cooldown: 1,
                mp: 724,
                cast: 1.5,
                info:
                    "Canaliza energia sagrada na ponta do cetro e a lança causando 1149 de dano mágico. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 60,
            },
        ],
    },
    {
        logoId: 2,
        name: "Cura",
        levelsInfo: [
            {
                level: 1,
                cooldown: 1,
                mp: 46,
                cast: 1,
                info: "Recupera 93 da sua vida ou de um aliado.",
                necessaryLevel: 4,
            },
            {
                level: 2,
                cooldown: 1,
                mp: 61,
                cast: 1,
                info: "Recupera 124 da sua vida ou de um aliado.",
                necessaryLevel: 8,
            },
            {
                level: 3,
                cooldown: 1,
                mp: 77,
                cast: 1,
                info: "Recupera 155 da sua vida ou de um aliado.",
                necessaryLevel: 12,
            },
            {
                level: 4,
                cooldown: 1,
                mp: 94,
                cast: 1,
                info: "Recupera 190 da sua vida ou de um aliado.",
                necessaryLevel: 16,
            },
            {
                level: 5,
                cooldown: 1,
                mp: 116,
                cast: 1,
                info: "Recupera 235 da sua vida ou de um aliado.",
                necessaryLevel: 20,
            },
            {
                level: 6,
                cooldown: 1,
                mp: 139,
                cast: 1,
                info: "Recupera 280 da sua vida ou de um aliado.",
                necessaryLevel: 24,
            },
            {
                level: 7,
                cooldown: 1,
                mp: 167,
                cast: 1,
                info: "Recupera 337 da sua vida ou de um aliado.",
                necessaryLevel: 28,
            },
            {
                level: 8,
                cooldown: 1,
                mp: 200,
                cast: 1,
                info: "Recupera 404 da sua vida ou de um aliado.",
                necessaryLevel: 32,
            },
            {
                level: 9,
                cooldown: 1,
                mp: 240,
                cast: 1,
                info: "Recupera 484 da sua vida ou de um aliado.",
                necessaryLevel: 36,
            },
            {
                level: 10,
                cooldown: 1,
                mp: 287,
                cast: 1,
                info: "Recupera 579 da sua vida ou de um aliado.",
                necessaryLevel: 40,
            },
            {
                level: 11,
                cooldown: 1,
                mp: 335,
                cast: 1,
                info: "Recupera 676 da sua vida ou de um aliado.",
                necessaryLevel: 44,
            },
            {
                level: 12,
                cooldown: 1,
                mp: 391,
                cast: 1,
                info: "Recupera 789 da sua vida ou de um aliado.",
                necessaryLevel: 48,
            },
            {
                level: 13,
                cooldown: 1,
                mp: 449,
                cast: 1,
                info: "Recupera 907 da sua vida ou de um aliado.",
                necessaryLevel: 52,
            },
            {
                level: 14,
                cooldown: 1,
                mp: 514,
                cast: 1,
                info: "Recupera 1039 da sua vida ou de um aliado.",
                necessaryLevel: 56,
            },
            {
                level: 15,
                cooldown: 1,
                mp: 585,
                cast: 1,
                info: "Recupera 1173 da sua vida ou de um aliado.",
                necessaryLevel: 60,
            },
            {
                level: 16,
                cooldown: 1,
                mp: 651,
                cast: 1,
                info:
                    "Recupera 1316 da sua vida ou de um aliado e purifica um efeito negativo.",
                necessaryLevel: 64,
            },
        ],
    },
    {
        logoId: 3,
        name: "Escudo Mágico",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 175,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 6,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 228,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 10,
            },
            {
                level: 3,
                cooldown: 19,
                mp: 286,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 14,
            },
            {
                level: 4,
                cooldown: 19,
                mp: 353,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 18,
            },
            {
                level: 5,
                cooldown: 18,
                mp: 434,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 22,
            },
            {
                level: 6,
                cooldown: 18,
                mp: 526,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 26,
            },
            {
                level: 7,
                cooldown: 17,
                mp: 636,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 30,
            },
            {
                level: 8,
                cooldown: 17,
                mp: 770,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 34,
            },
            {
                level: 9,
                cooldown: 16,
                mp: 934,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 38,
            },
            {
                level: 10,
                cooldown: 16,
                mp: 1109,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 42,
            },
            {
                level: 11,
                cooldown: 15,
                mp: 1308,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 46,
            },
            {
                level: 12,
                cooldown: 15,
                mp: 1536,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 50,
            },
            {
                level: 13,
                cooldown: 14,
                mp: 1778,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 54,
            },
            {
                level: 14,
                cooldown: 14,
                mp: 2052,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 58,
            },
            {
                level: 15,
                cooldown: 13,
                mp: 2333,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 62,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 2623,
                cast: 0,
                info:
                    "Cria um escudo mágico em si ou em um aliado absorvendo 438 de dano e reduzindo 25% de ataques físicos recebidos por habilidades em área durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 66,
            },
        ],
    },
    {
        logoId: 4,
        name: "Bênção",
        levelsInfo: [
            {
                level: 1,
                cooldown: 2,
                mp: 98,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 13 de ataque físico e 17 de ataque mágico durante 60 minutos.",
                necessaryLevel: 8,
            },
            {
                level: 2,
                cooldown: 2,
                mp: 122,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 16 de ataque físico e 21 de ataque mágico durante 60 minutos.",
                necessaryLevel: 12,
            },
            {
                level: 3,
                cooldown: 2,
                mp: 151,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 20 de ataque físico e 25 de ataque mágico durante 60 minutos.",
                necessaryLevel: 16,
            },
            {
                level: 4,
                cooldown: 2,
                mp: 190,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 24 de ataque físico e 31 de ataque mágico durante 60 minutos.",
                necessaryLevel: 20,
            },
            {
                level: 5,
                cooldown: 2,
                mp: 236,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 28 de ataque físico e 37 de ataque mágico durante 60 minutos.",
                necessaryLevel: 24,
            },
            {
                level: 6,
                cooldown: 2,
                mp: 285,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 34 de ataque físico e 44 de ataque mágico durante 60 minutos.",
                necessaryLevel: 28,
            },
            {
                level: 7,
                cooldown: 2,
                mp: 342,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 40 de ataque físico e 52 de ataque mágico durante 60 minutos.",
                necessaryLevel: 32,
            },
            {
                level: 8,
                cooldown: 2,
                mp: 409,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 48 de ataque físico e 61 de ataque mágico durante 60 minutos.",
                necessaryLevel: 36,
            },
            {
                level: 9,
                cooldown: 2,
                mp: 497,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 56 de ataque físico e 72 de ataque mágico durante 60 minutos.",
                necessaryLevel: 40,
            },
            {
                level: 10,
                cooldown: 2,
                mp: 598,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 64 de ataque físico e 83 de ataque mágico durante 60 minutos.",
                necessaryLevel: 44,
            },
            {
                level: 11,
                cooldown: 2,
                mp: 708,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 74 de ataque físico e 96 de ataque mágico durante 60 minutos.",
                necessaryLevel: 48,
            },
            {
                level: 12,
                cooldown: 2,
                mp: 834,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 86 de ataque físico e 111 de ataque mágico durante 60 minutos.",
                necessaryLevel: 52,
            },
            {
                level: 13,
                cooldown: 2,
                mp: 965,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 98 de ataque físico e 127 de ataque mágico durante 60 minutos.",
                necessaryLevel: 56,
            },
            {
                level: 14,
                cooldown: 2,
                mp: 1109,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 111 de ataque físico e 143 de ataque mágico durante 60 minutos.",
                necessaryLevel: 60,
            },
            {
                level: 15,
                cooldown: 2,
                mp: 1262,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados aumentando 124 de ataque físico e 160 de ataque mágico durante 60 minutos.",
                necessaryLevel: 64,
            },
            {
                level: 16,
                cooldown: 2,
                mp: 1429,
                cast: 2,
                info:
                    "Abençoa a si mesmo ou aos aliados em uma área de 20 metros aumentando 145 de ataque físico e 187 de ataque mágico durante 60 minutos.",
                necessaryLevel: 68,
            },
        ],
    },
    {
        logoId: 5,
        name: "Mão da Cura",
        levelsInfo: [
            {
                level: 1,
                cooldown: 2,
                mp: 103,
                cast: 0,
                info:
                    "Restaura 79 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 10,
            },
            {
                level: 2,
                cooldown: 2,
                mp: 128,
                cast: 0,
                info:
                    "Restaura 98 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 14,
            },
            {
                level: 3,
                cooldown: 2,
                mp: 157,
                cast: 0,
                info:
                    "Restaura 120 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 18,
            },
            {
                level: 4,
                cooldown: 2,
                mp: 191,
                cast: 0,
                info:
                    "Restaura 146 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 22,
            },
            {
                level: 5,
                cooldown: 2,
                mp: 229,
                cast: 0,
                info:
                    "Restaura 176 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 26,
            },
            {
                level: 6,
                cooldown: 2,
                mp: 274,
                cast: 0,
                info:
                    "Restaura 210 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 30,
            },
            {
                level: 7,
                cooldown: 2,
                mp: 328,
                cast: 0,
                info:
                    "Restaura 252 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 34,
            },
            {
                level: 8,
                cooldown: 2,
                mp: 395,
                cast: 0,
                info:
                    "Restaura 303 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 9,
                cooldown: 2,
                mp: 463,
                cast: 0,
                info:
                    "Restaura 356 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 42,
            },
            {
                level: 10,
                cooldown: 2,
                mp: 542,
                cast: 0,
                info:
                    "Restaura 416 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 46,
            },
            {
                level: 11,
                cooldown: 2,
                mp: 630,
                cast: 0,
                info:
                    "Restaura 483 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 50,
            },
            {
                level: 12,
                cooldown: 2,
                mp: 721,
                cast: 0,
                info:
                    "Restaura 553 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 54,
            },
            {
                level: 13,
                cooldown: 2,
                mp: 827,
                cast: 0,
                info:
                    "Restaura 630 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 58,
            },
            {
                level: 14,
                cooldown: 2,
                mp: 927,
                cast: 0,
                info:
                    "Restaura 711 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 62,
            },
            {
                level: 15,
                cooldown: 2,
                mp: 1032,
                cast: 0,
                info:
                    "Restaura 792 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 66,
            },
            {
                level: 16,
                cooldown: 2,
                mp: 1146,
                cast: 0,
                info:
                    "Restaura 880 de vida de si mesmo ou um aliado a cada 2 segundos durante 10 segundos.",
                necessaryLevel: 70,
            },
        ],
    },
    {
        logoId: 6,
        name: "Ressureição",
        levelsInfo: [
            {
                level: 1,
                cooldown: 33,
                mp: 222,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 10% da vida e mana.",
                necessaryLevel: 12,
            },
            {
                level: 2,
                cooldown: 30,
                mp: 274,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 20% da vida e mana.",
                necessaryLevel: 16,
            },
            {
                level: 3,
                cooldown: 27,
                mp: 359,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 30% da vida e mana.",
                necessaryLevel: 20,
            },
            {
                level: 4,
                cooldown: 24,
                mp: 429,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 40% da vida e mana.",
                necessaryLevel: 24,
            },
            {
                level: 5,
                cooldown: 21,
                mp: 518,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 50% da vida e mana.",
                necessaryLevel: 28,
            },
            {
                level: 6,
                cooldown: 18,
                mp: 621,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 60% da vida e mana.",
                necessaryLevel: 32,
            },
            {
                level: 7,
                cooldown: 15,
                mp: 744,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 70% da vida e mana.",
                necessaryLevel: 36,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 943,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 80% da vida e mana.",
                necessaryLevel: 40,
            },
            {
                level: 9,
                cooldown: 9,
                mp: 1103,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 90% da vida e mana.",
                necessaryLevel: 44,
            },
            {
                level: 10,
                cooldown: 6,
                mp: 1286,
                cast: 5,
                info:
                    "Ressucita um membro do grupo ou raid que renasce com 100% da vida e mana.",
                necessaryLevel: 48,
            },
        ],
    },
    {
        logoId: 7,
        name: "Velocidade",
        levelsInfo: [
            {
                level: 1,
                cooldown: 3,
                mp: 159,
                cast: 2,
                info:
                    "Aumenta em 5 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 17,
            },
            {
                level: 2,
                cooldown: 3,
                mp: 208,
                cast: 2,
                info:
                    "Aumenta em 6 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 21,
            },
            {
                level: 3,
                cooldown: 3,
                mp: 248,
                cast: 2,
                info:
                    "Aumenta em 7 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 25,
            },
            {
                level: 4,
                cooldown: 3,
                mp: 297,
                cast: 2,
                info:
                    "Aumenta em 8 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 29,
            },
            {
                level: 5,
                cooldown: 3,
                mp: 358,
                cast: 2,
                info:
                    "Aumenta em 9 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 33,
            },
            {
                level: 6,
                cooldown: 3,
                mp: 429,
                cast: 2,
                info:
                    "Aumenta em 10 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 37,
            },
            {
                level: 7,
                cooldown: 3,
                mp: 521,
                cast: 2,
                info:
                    "Aumenta em 11 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 41,
            },
            {
                level: 8,
                cooldown: 3,
                mp: 625,
                cast: 2,
                info:
                    "Aumenta em 12 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 45,
            },
            {
                level: 9,
                cooldown: 3,
                mp: 734,
                cast: 2,
                info:
                    "Aumenta em 13 a velocidade de movimento de si ou aos aliados durante 60 minutos.",
                necessaryLevel: 49,
            },
            {
                level: 10,
                cooldown: 3,
                mp: 891,
                cast: 2,
                info:
                    "Aumenta em 15 a velocidade de movimento de si ou aos aliados em uma área de 20 metros durante 60 minutos.",
                necessaryLevel: 53,
            },
        ],
    },
    {
        logoId: 8,
        name: "Raio Solar",
        levelsInfo: [
            {
                level: 1,
                cooldown: 12,
                mp: 189,
                cast: 0,
                info:
                    "Causa 84 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 19,
            },
            {
                level: 2,
                cooldown: 12,
                mp: 230,
                cast: 0,
                info:
                    "Causa 102 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 23,
            },
            {
                level: 3,
                cooldown: 12,
                mp: 279,
                cast: 0,
                info:
                    "Causa 124 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 27,
            },
            {
                level: 4,
                cooldown: 12,
                mp: 338,
                cast: 0,
                info:
                    "Causa 150 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 31,
            },
            {
                level: 5,
                cooldown: 12,
                mp: 407,
                cast: 0,
                info:
                    "Causa 181 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 35,
            },
            {
                level: 6,
                cooldown: 12,
                mp: 493,
                cast: 0,
                info:
                    "Causa 219 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 39,
            },
            {
                level: 7,
                cooldown: 12,
                mp: 583,
                cast: 0,
                info:
                    "Causa 259 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 43,
            },
            {
                level: 8,
                cooldown: 12,
                mp: 686,
                cast: 0,
                info:
                    "Causa 305 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 47,
            },
            {
                level: 9,
                cooldown: 12,
                mp: 803,
                cast: 0,
                info:
                    "Causa 357 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 51,
            },
            {
                level: 10,
                cooldown: 12,
                mp: 927,
                cast: 0,
                info:
                    "Causa 412 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 55,
            },
            {
                level: 11,
                cooldown: 12,
                mp: 1065,
                cast: 0,
                info:
                    "Causa 473 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 59,
            },
            {
                level: 12,
                cooldown: 12,
                mp: 1211,
                cast: 0,
                info:
                    "Causa 538 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 63,
            },
            {
                level: 13,
                cooldown: 12,
                mp: 1361,
                cast: 0,
                info:
                    "Causa 605 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 67,
            },
            {
                level: 14,
                cooldown: 12,
                mp: 1528,
                cast: 0,
                info:
                    "Causa 679 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 71,
            },
            {
                level: 15,
                cooldown: 12,
                mp: 1712,
                cast: 0,
                info:
                    "Causa 761 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 75,
            },
            {
                level: 16,
                cooldown: 12,
                mp: 1904,
                cast: 0,
                info:
                    "Causa 846 de dano mágico em todos os alvos em uma área de 4 metros a cada 2 segundos durante 12 segundos deixando o alvo enfraquecido contra magia sagrada.",
                necessaryLevel: 79,
            },
        ],
    },
    {
        logoId: 9,
        name: "Ativação Divina",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 120 pontos e reduz o custo de mana das habilidades de cura em 10%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 21,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 240 pontos e reduz o custo de mana das habilidades de cura em 12%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 25,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 360 pontos e reduz o custo de mana das habilidades de cura em 14%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 29,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 480 pontos e reduz o custo de mana das habilidades de cura em 16%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 33,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 560 pontos e reduz o custo de mana das habilidades de cura em 18%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 37,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 720 pontos e reduz o custo de mana das habilidades de cura em 20%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 41,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 840 pontos e reduz o custo de mana das habilidades de cura em 22%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 45,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 960 pontos e reduz o custo de mana das habilidades de cura em 24%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 49,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 1080 pontos e reduz o custo de mana das habilidades de cura em 26%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 53,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o poder de suas curas em 1200 pontos e reduz o custo de mana das habilidades de cura em 30%. As habilidades de cura que possuem longa canalização se beneficiam melhor dessa amplificação.",
                necessaryLevel: 57,
            },
        ],
    },
    {
        logoId: 10,
        name: "Ativação de Mana",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 2 minutos e consomem 10% menos mana.",
                necessaryLevel: 23,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 4 minutos e consomem 12% menos mana.",
                necessaryLevel: 27,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 6 minutos e consomem 14% menos mana.",
                necessaryLevel: 31,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 8 minutos e consomem 16% menos mana.",
                necessaryLevel: 35,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 10 minutos e consomem 18% menos mana.",
                necessaryLevel: 39,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 12 minutos e consomem 20% menos mana.",
                necessaryLevel: 43,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 14 minutos e consomem 22% menos mana.",
                necessaryLevel: 47,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 16 minutos e consomem 24% menos mana.",
                necessaryLevel: 51,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 18 minutos e consomem 26% menos mana.",
                necessaryLevel: 55,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta a duração das habilidades Bênção, Velocidade, Golpe Divino e Afiar Arma em 20 minutos e consomem 30% menos mana.",
                necessaryLevel: 59,
            },
        ],
    },
    {
        logoId: 11,
        name: "Cura em Massa Defensiva",
        levelsInfo: [
            {
                level: 1,
                cooldown: 3,
                mp: 340,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 441 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 331 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 25,
            },
            {
                level: 2,
                cooldown: 3,
                mp: 408,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 530 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 398 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 29,
            },
            {
                level: 3,
                cooldown: 3,
                mp: 491,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 638 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 479 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 33,
            },
            {
                level: 4,
                cooldown: 3,
                mp: 588,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 764 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 573 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 37,
            },
            {
                level: 5,
                cooldown: 3,
                mp: 693,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 900 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 675 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 41,
            },
            {
                level: 6,
                cooldown: 3,
                mp: 811,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 1053 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 790 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 45,
            },
            {
                level: 7,
                cooldown: 3,
                mp: 946,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 1229 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 922 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 49,
            },
            {
                level: 8,
                cooldown: 3,
                mp: 1083,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 1407 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 1055 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 53,
            },
            {
                level: 9,
                cooldown: 3,
                mp: 1242,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 1613 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 1209 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 57,
            },
            {
                level: 10,
                cooldown: 3,
                mp: 1401,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 1820 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 1364 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 61,
            },
            {
                level: 11,
                cooldown: 3,
                mp: 1561,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 2027 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 1520 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 65,
            },
            {
                level: 12,
                cooldown: 3,
                mp: 1737,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 2256 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 1692 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 69,
            },
            {
                level: 13,
                cooldown: 3,
                mp: 1933,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 2510 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 1883 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 73,
            },
            {
                level: 14,
                cooldown: 3,
                mp: 2130,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 2766 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 2075 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 77,
            },
            {
                level: 15,
                cooldown: 3,
                mp: 2340,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 3039 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 2279 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 81,
            },
            {
                level: 16,
                cooldown: 3,
                mp: 2571,
                cast: 2,
                info:
                    "Canaliza durante um tempo e restaura 3339 de vida de todos os membros do grupo em um raio de 6 metros criando um escudo que absorve 2504 de dano físico durante 60 segundos. O escudo sempre é reduzido com base no ataque físico e habilidades que não causam dano físico também reduzem a absorção do escudo.",
                necessaryLevel: 85,
            },
        ],
    },
    {
        logoId: 12,
        name: "Uegenes Lux",
        levelsInfo: [
            {
                level: 1,
                cooldown: 3,
                mp: 213,
                cast: 0,
                info:
                    "Causa 284 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 27,
            },
            {
                level: 2,
                cooldown: 3,
                mp: 258,
                cast: 0,
                info:
                    "Causa 344 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 31,
            },
            {
                level: 3,
                cooldown: 3,
                mp: 312,
                cast: 0,
                info:
                    "Causa 416 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 35,
            },
            {
                level: 4,
                cooldown: 3,
                mp: 378,
                cast: 0,
                info:
                    "Causa 504 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 39,
            },
            {
                level: 5,
                cooldown: 3,
                mp: 447,
                cast: 0,
                info:
                    "Causa 596 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 43,
            },
            {
                level: 6,
                cooldown: 3,
                mp: 527,
                cast: 0,
                info:
                    "Causa 702 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 47,
            },
            {
                level: 7,
                cooldown: 3,
                mp: 615,
                cast: 0,
                info:
                    "Causa 820 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 51,
            },
            {
                level: 8,
                cooldown: 3,
                mp: 711,
                cast: 0,
                info:
                    "Causa 948 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 55,
            },
            {
                level: 9,
                cooldown: 3,
                mp: 822,
                cast: 0,
                info:
                    "Causa 1088 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 59,
            },
            {
                level: 10,
                cooldown: 3,
                mp: 927,
                cast: 0,
                info:
                    "Causa 1236 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 63,
            },
            {
                level: 11,
                cooldown: 3,
                mp: 1043,
                cast: 0,
                info:
                    "Causa 1390 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 67,
            },
            {
                level: 12,
                cooldown: 3,
                mp: 1172,
                cast: 0,
                info:
                    "Causa 1562 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 71,
            },
            {
                level: 13,
                cooldown: 3,
                mp: 1313,
                cast: 0,
                info:
                    "Causa 1750 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 75,
            },
            {
                level: 14,
                cooldown: 3,
                mp: 1458,
                cast: 0,
                info:
                    "Causa 1944 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 79,
            },
            {
                level: 15,
                cooldown: 3,
                mp: 1620,
                cast: 0,
                info:
                    "Causa 2160 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 83,
            },
            {
                level: 16,
                cooldown: 3,
                mp: 1799,
                cast: 0,
                info:
                    "Causa 2398 de dano mágico em uma seleção de área de 4 metros. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 13,
        name: "Liberação de Mana",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 217 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 32,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 260 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 36,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 316 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 40,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 380 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 44,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 450 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 48,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 530 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 52,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 613 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 56,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 704 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 60,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 802 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 64,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 905 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 68,
            },
            {
                level: 11,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 1012 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 72,
            },
            {
                level: 12,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 1125 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 76,
            },
            {
                level: 13,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 1250 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 80,
            },
            {
                level: 14,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 1386 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 84,
            },
            {
                level: 15,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 1524 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 88,
            },
            {
                level: 16,
                cooldown: 180,
                mp: 10,
                cast: 2,
                info:
                    "Restaura 1763 de mana por segundo de todos os membros do grupo em um raio de 6 metros durante 10 segundos.",
                necessaryLevel: 92,
            },
        ],
    },
    {
        logoId: 14,
        name: "Cura Preventiva",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 292,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 663 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 34,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 351,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 797 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 38,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 412,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 936 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 42,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 481,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 1094 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 46,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 560,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 1272 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 50,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 641,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 1457 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 54,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 735,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 1659 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 58,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 824,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 1871 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 62,
            },
            {
                level: 9,
                cooldown: 20,
                mp: 917,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 2084 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 66,
            },
            {
                level: 10,
                cooldown: 20,
                mp: 1019,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 2315 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 70,
            },
            {
                level: 11,
                cooldown: 20,
                mp: 1133,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 2570 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 74,
            },
            {
                level: 12,
                cooldown: 20,
                mp: 1246,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 2831 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 78,
            },
            {
                level: 13,
                cooldown: 20,
                mp: 1369,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 3111 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 82,
            },
            {
                level: 14,
                cooldown: 20,
                mp: 1504,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 3419 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 86,
            },
            {
                level: 15,
                cooldown: 20,
                mp: 1652,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 3755 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 90,
            },
            {
                level: 16,
                cooldown: 20,
                mp: 1815,
                cast: 0,
                info:
                    "Aplica em si ou em algum membro do grupo uma proteção que recupera 4124 de vida caso a mesma fique inferior a 50% ou após 60 segundos.",
                necessaryLevel: 94,
            },
        ],
    },
    {
        logoId: 15,
        name: "Escudo de Nikita",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 372,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 3 segundos e impossibilita o uso de magias.",
                necessaryLevel: 36,
            },
            {
                level: 2,
                cooldown: 170,
                mp: 472,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 3 segundos e impossibilita o uso de magias.",
                necessaryLevel: 40,
            },
            {
                level: 3,
                cooldown: 160,
                mp: 552,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 3 segundos e impossibilita o uso de magias.",
                necessaryLevel: 44,
            },
            {
                level: 4,
                cooldown: 160,
                mp: 643,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 4 segundos e impossibilita o uso de magias.",
                necessaryLevel: 48,
            },
            {
                level: 5,
                cooldown: 150,
                mp: 783,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 4 segundos e impossibilita o uso de magias.",
                necessaryLevel: 52,
            },
            {
                level: 6,
                cooldown: 140,
                mp: 897,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 4 segundos e impossibilita o uso de magias.",
                necessaryLevel: 56,
            },
            {
                level: 7,
                cooldown: 140,
                mp: 1049,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 5 segundos e impossibilita o uso de magias.",
                necessaryLevel: 60,
            },
            {
                level: 8,
                cooldown: 130,
                mp: 1168,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 5 segundos e impossibilita o uso de magias.",
                necessaryLevel: 64,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 1299,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 5 segundos e impossibilita o uso de magias.",
                necessaryLevel: 68,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 1446,
                cast: 1,
                info:
                    "Conjura uma proteção que evita todos os danos recebidos durante 6 segundos e impossibilita o uso de magias.",
                necessaryLevel: 72,
            },
        ],
    },
    {
        logoId: 16,
        name: "Retorno da Mágica",
        levelsInfo: [
            {
                level: 1,
                cooldown: 40,
                mp: 162,
                cast: 1,
                info:
                    "Remove 2 feitiços benéficos do alvo e causa 360 de dano mágico para cada feitiço removido.",
                necessaryLevel: 38,
            },
            {
                level: 2,
                cooldown: 40,
                mp: 193,
                cast: 1,
                info:
                    "Remove 2 feitiços benéficos do alvo e causa 428 de dano mágico para cada feitiço removido.",
                necessaryLevel: 42,
            },
            {
                level: 3,
                cooldown: 40,
                mp: 227,
                cast: 1,
                info:
                    "Remove 2 feitiços benéficos do alvo e causa 511 de dano mágico para cada feitiço removido.",
                necessaryLevel: 46,
            },
            {
                level: 4,
                cooldown: 40,
                mp: 267,
                cast: 1,
                info:
                    "Remove 3 feitiços benéficos do alvo e causa 593 de dano mágico para cada feitiço removido.",
                necessaryLevel: 50,
            },
            {
                level: 5,
                cooldown: 40,
                mp: 309,
                cast: 1,
                info:
                    "Remove 3 feitiços benéficos do alvo e causa 825 de dano mágico para cada feitiço removido.",
                necessaryLevel: 54,
            },
            {
                level: 6,
                cooldown: 40,
                mp: 357,
                cast: 1,
                info:
                    "Remove 3 feitiços benéficos do alvo e causa 1056 de dano mágico para cada feitiço removido.",
                necessaryLevel: 58,
            },
            {
                level: 7,
                cooldown: 40,
                mp: 405,
                cast: 1,
                info:
                    "Remove 4 feitiços benéficos do alvo e causa 1160 de dano mágico para cada feitiço removido.",
                necessaryLevel: 62,
            },
            {
                level: 8,
                cooldown: 40,
                mp: 455,
                cast: 1,
                info:
                    "Remove 4 feitiços benéficos do alvo e causa 1264 de dano mágico para cada feitiço removido.",
                necessaryLevel: 66,
            },
            {
                level: 9,
                cooldown: 40,
                mp: 512,
                cast: 1,
                info:
                    "Remove 4 feitiços benéficos do alvo e causa 1399 de dano mágico para cada feitiço removido.",
                necessaryLevel: 70,
            },
            {
                level: 10,
                cooldown: 40,
                mp: 575,
                cast: 1,
                info:
                    "Remove 5 feitiços benéficos do alvo e causa 1534 de dano mágico para cada feitiço removido.",
                necessaryLevel: 74,
            },
        ],
    },
    {
        logoId: 17,
        name: "Golpe Divino",
        levelsInfo: [
            {
                level: 1,
                cooldown: 2,
                mp: 519,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 10% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 2,
                mp: 607,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 12% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 2,
                mp: 708,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 14% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 2,
                mp: 834,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 16% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 2,
                mp: 965,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 18% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 2,
                mp: 1109,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 20% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 2,
                mp: 1262,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 22% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 2,
                mp: 1424,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 24% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 2,
                mp: 1591,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados ampliando o dano causado em 26% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 2,
                mp: 1807,
                cast: 2,
                info:
                    "Atribui a força divina na sua arma ou na dos aliados em uma área de 20 metros ampliando o dano causado em 30% em alvos Demônios e Mortos-Vivos.",
                necessaryLevel: 76,
            },
        ],
    },
    {
        logoId: 18,
        name: "Recuperação",
        levelsInfo: [
            {
                level: 1,
                cooldown: 2,
                mp: 764,
                cast: 1,
                info:
                    "Recupera 1737 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 40,
            },
            {
                level: 2,
                cooldown: 2,
                mp: 892,
                cast: 1,
                info:
                    "Recupera 2028 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 44,
            },
            {
                level: 3,
                cooldown: 2,
                mp: 1041,
                cast: 1,
                info:
                    "Recupera 2367 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 48,
            },
            {
                level: 4,
                cooldown: 2,
                mp: 1197,
                cast: 1,
                info:
                    "Recupera 2721 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 52,
            },
            {
                level: 5,
                cooldown: 2,
                mp: 1371,
                cast: 1,
                info:
                    "Recupera 3117 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 56,
            },
            {
                level: 6,
                cooldown: 2,
                mp: 1560,
                cast: 1,
                info:
                    "Recupera 3519 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 60,
            },
            {
                level: 7,
                cooldown: 2,
                mp: 1737,
                cast: 1,
                info:
                    "Recupera 3948 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 64,
            },
            {
                level: 8,
                cooldown: 2,
                mp: 1931,
                cast: 1,
                info:
                    "Recupera 4389 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 68,
            },
            {
                level: 9,
                cooldown: 2,
                mp: 2150,
                cast: 1,
                info:
                    "Recupera 4887 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 72,
            },
            {
                level: 10,
                cooldown: 2,
                mp: 2377,
                cast: 1,
                info:
                    "Recupera 5403 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 76,
            },
            {
                level: 11,
                cooldown: 2,
                mp: 2612,
                cast: 1,
                info:
                    "Recupera 5937 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 80,
            },
            {
                level: 12,
                cooldown: 2,
                mp: 2870,
                cast: 1,
                info:
                    "Recupera 6522 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 84,
            },
            {
                level: 13,
                cooldown: 2,
                mp: 3152,
                cast: 1,
                info:
                    "Recupera 7149 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 88,
            },
            {
                level: 14,
                cooldown: 2,
                mp: 3464,
                cast: 1,
                info:
                    "Recupera 7791 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 92,
            },
            {
                level: 15,
                cooldown: 2,
                mp: 3803,
                cast: 1,
                info:
                    "Recupera 8499 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 96,
            },
            {
                level: 16,
                cooldown: 2,
                mp: 4079,
                cast: 1,
                info:
                    "Recupera 9210 de vida de si ou de um aliado e purifica os efeitos negativos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 19,
        name: "Afiar Arma",
        levelsInfo: [
            {
                level: 1,
                cooldown: 3,
                mp: 833,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 2 e o dano crítico em 10 durante 60 minutos.",
                necessaryLevel: 51,
            },
            {
                level: 2,
                cooldown: 3,
                mp: 954,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 4 e o dano crítico em 12 durante 60 minutos.",
                necessaryLevel: 55,
            },
            {
                level: 3,
                cooldown: 3,
                mp: 1092,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 6 e o dano crítico em 14 durante 60 minutos.",
                necessaryLevel: 59,
            },
            {
                level: 4,
                cooldown: 3,
                mp: 1233,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 9 e o dano crítico em 16 durante 60 minutos.",
                necessaryLevel: 63,
            },
            {
                level: 5,
                cooldown: 3,
                mp: 1389,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 10 e o dano crítico em 18 durante 60 minutos.",
                necessaryLevel: 67,
            },
            {
                level: 6,
                cooldown: 3,
                mp: 1549,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 12 e o dano crítico em 20 durante 60 minutos.",
                necessaryLevel: 71,
            },
            {
                level: 7,
                cooldown: 3,
                mp: 1723,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 14 e o dano crítico em 22 durante 60 minutos.",
                necessaryLevel: 75,
            },
            {
                level: 8,
                cooldown: 3,
                mp: 1914,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 16 e o dano crítico em 24 durante 60 minutos.",
                necessaryLevel: 79,
            },
            {
                level: 9,
                cooldown: 3,
                mp: 2125,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados aumentando o critico em 18 e o dano crítico em 26 durante 60 minutos.",
                necessaryLevel: 83,
            },
            {
                level: 10,
                cooldown: 3,
                mp: 2341,
                cast: 2,
                info:
                    "Potencializa a si mesmo ou aliados em uma área de 20 metros aumentando o critico em 30 e o dano crítico em 10 durante 60 minutos.",
                necessaryLevel: 87,
            },
        ],
    },
    {
        logoId: 20,
        name: "Vontade Inabalável",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 5% e contra estado de choque em 3%.",
                necessaryLevel: 55,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 10% e contra estado de choque em 6%.",
                necessaryLevel: 59,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 15% e contra estado de choque em 9%.",
                necessaryLevel: 63,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 20% e contra estado de choque em 12%.",
                necessaryLevel: 67,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 25% e contra estado de choque em 15%.",
                necessaryLevel: 71,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 30% e contra estado de choque em 18%.",
                necessaryLevel: 75,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 35% e contra estado de choque em 21%.",
                necessaryLevel: 79,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 40% e contra estado de choque em 24%.",
                necessaryLevel: 83,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 45% e contra estado de choque em 27%.",
                necessaryLevel: 87,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Pela devoção cria resistência contra atordoamentos em 50% e contra estado de choque em 30%.",
                necessaryLevel: 91,
            },
        ],
    },
    {
        logoId: 21,
        name: "Aura Esplendor",
        levelsInfo: [
            {
                level: 1,
                cooldown: 120,
                mp: 1898,
                cast: 0,
                info:
                    "Concede uma aura que recupera 5750 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 5 segundos.",
                necessaryLevel: 59,
            },
            {
                level: 2,
                cooldown: 120,
                mp: 2115,
                cast: 0,
                info:
                    "Concede uma aura que recupera 6410 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 5 segundos.",
                necessaryLevel: 63,
            },
            {
                level: 3,
                cooldown: 120,
                mp: 2353,
                cast: 0,
                info:
                    "Concede uma aura que recupera 7130 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 6 segundos.",
                necessaryLevel: 67,
            },
            {
                level: 4,
                cooldown: 120,
                mp: 2617,
                cast: 0,
                info:
                    "Concede uma aura que recupera 7930 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 6 segundos.",
                necessaryLevel: 71,
            },
            {
                level: 5,
                cooldown: 120,
                mp: 2902,
                cast: 0,
                info:
                    "Concede uma aura que recupera 8795 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 7 segundos.",
                necessaryLevel: 75,
            },
            {
                level: 6,
                cooldown: 120,
                mp: 3188,
                cast: 0,
                info:
                    "Concede uma aura que recupera 9660 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 7 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 7,
                cooldown: 120,
                mp: 3505,
                cast: 0,
                info:
                    "Concede uma aura que recupera 10620 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 8 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 8,
                cooldown: 120,
                mp: 3851,
                cast: 0,
                info:
                    "Concede uma aura que recupera 11670 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 8 segundos.",
                necessaryLevel: 87,
            },
            {
                level: 9,
                cooldown: 120,
                mp: 4229,
                cast: 0,
                info:
                    "Concede uma aura que recupera 12815 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 9 segundos.",
                necessaryLevel: 91,
            },
            {
                level: 10,
                cooldown: 120,
                mp: 4643,
                cast: 0,
                info:
                    "Concede uma aura que recupera 14070 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 9 segundos.",
                necessaryLevel: 95,
            },
            {
                level: 11,
                cooldown: 120,
                mp: 5099,
                cast: 0,
                info:
                    "Concede uma aura que recupera 15450 da sua vida e mana ou de um aliado e mantém imune a todos os ataques durante 10 segundos.",
                necessaryLevel: 99,
            },
        ],
        logo: "/static/media/21.2385f052.jpg",
    },
    {
        logoId: 22,
        name: "Escudo Sagrado",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 2097,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 4194 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 61,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 2358,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 4716 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 65,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 2652,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 5304 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 69,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 2982,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 5964 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 73,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 3321,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 6642 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 77,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 3687,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 7374 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 81,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 4095,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 8190 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 85,
            },
            {
                level: 8,
                cooldown: 180,
                mp: 4548,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 9096 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 89,
            },
            {
                level: 9,
                cooldown: 180,
                mp: 5052,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 10104 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 93,
            },
            {
                level: 10,
                cooldown: 180,
                mp: 5613,
                cast: 0,
                info:
                    "Cria uma barreira ao redor do corpo e dos aliados absorvendo 11226 de dano mágico durante 3 minutos reduzindo 25% dos ataques mágicos recebidos por habilidades de área. O escudo sempre é reduzido com base no ataque mágico e habilidades que não causam dano mágico também reduzem a absorção do escudo.",
                necessaryLevel: 97,
            },
        ],
    },
    {
        logoId: 23,
        name: "Penitência",
        levelsInfo: [
            {
                level: 1,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 20% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 65,
            },
            {
                level: 2,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 23% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 69,
            },
            {
                level: 3,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 26% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 73,
            },
            {
                level: 4,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 29% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 77,
            },
            {
                level: 5,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 32% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 81,
            },
            {
                level: 6,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 35% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 85,
            },
            {
                level: 7,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 38% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 89,
            },
            {
                level: 8,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 41% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 93,
            },
            {
                level: 9,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 44% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 97,
            },
            {
                level: 10,
                cooldown: 0,
                mp: 0,
                cast: 0,
                info:
                    "Aumenta o efeito da taxa de cura em 50% nas habilidades que possuem o tempo de conjuração acima de 1 segundo.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 24,
        name: "Glória de Excelsis",
        levelsInfo: [
            {
                level: 1,
                cooldown: 300,
                mp: 2482,
                cast: 11,
                info:
                    "Recupera 752 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 69,
            },
            {
                level: 2,
                cooldown: 300,
                mp: 2759,
                cast: 11,
                info:
                    "Recupera 836 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 73,
            },
            {
                level: 3,
                cooldown: 300,
                mp: 3043,
                cast: 11,
                info:
                    "Recupera 922 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 77,
            },
            {
                level: 4,
                cooldown: 300,
                mp: 3343,
                cast: 11,
                info:
                    "Recupera 1013 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 81,
            },
            {
                level: 5,
                cooldown: 300,
                mp: 3673,
                cast: 11,
                info:
                    "Recupera 1113 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 85,
            },
            {
                level: 6,
                cooldown: 300,
                mp: 4033,
                cast: 11,
                info:
                    "Recupera 1222 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 89,
            },
            {
                level: 7,
                cooldown: 300,
                mp: 4429,
                cast: 11,
                info:
                    "Recupera 1342 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 93,
            },
            {
                level: 8,
                cooldown: 300,
                mp: 4846,
                cast: 11,
                info:
                    "Recupera 1474 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 97,
            },
            {
                level: 9,
                cooldown: 300,
                mp: 5099,
                cast: 11,
                info:
                    "Recupera 1545 da sua vida e do grupo por vez dentro de uma área de 10 metros no máximo 10 vezes. Remove um efeito negativo por cada recuperação recebida.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 25,
        name: "Cruz Penitencial",
        levelsInfo: [
            {
                level: 1,
                cooldown: 20,
                mp: 1406,
                cast: 0,
                info:
                    "Causa 1874 de dano mágico e diminui o ataque físico e mágico em 28% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 71,
            },
            {
                level: 2,
                cooldown: 20,
                mp: 1575,
                cast: 0,
                info:
                    "Causa 2100 de dano mágico e diminui o ataque físico e mágico em 31% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 75,
            },
            {
                level: 3,
                cooldown: 20,
                mp: 1750,
                cast: 0,
                info:
                    "Causa 2333 de dano mágico e diminui o ataque físico e mágico em 34% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 79,
            },
            {
                level: 4,
                cooldown: 20,
                mp: 1944,
                cast: 0,
                info:
                    "Causa 2592 de dano mágico e diminui o ataque físico e mágico em 37% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 83,
            },
            {
                level: 5,
                cooldown: 20,
                mp: 2159,
                cast: 0,
                info:
                    "Causa 2878 de dano mágico e diminui o ataque físico e mágico em 40% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 87,
            },
            {
                level: 6,
                cooldown: 20,
                mp: 2398,
                cast: 0,
                info:
                    "Causa 3197 de dano mágico e diminui o ataque físico e mágico em 43% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 91,
            },
            {
                level: 7,
                cooldown: 20,
                mp: 2663,
                cast: 0,
                info:
                    "Causa 3550 de dano mágico e diminui o ataque físico e mágico em 46% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 95,
            },
            {
                level: 8,
                cooldown: 20,
                mp: 2956,
                info:
                    "Causa 3941 de dano mágico e diminui o ataque físico e mágico em 50% dos alvos por 10 segundos. Esse dano é aumentado em 50% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 26,
        name: "Criação de Água Benta",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 8824,
                cast: 3,
                info:
                    "Cria a poção Água Benta nível 1 no inventário que restaura vida e mana ao ser consumida mesmo sob condições debilitantes e fornece aumento temporário de dano físico, dano mágico, defesa física e defesa mágica. Apenas uma pode ser armazenada.",
                necessaryLevel: 75,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 9693,
                cast: 3,
                info:
                    "Cria a poção Água Benta nível 2 no inventário que restaura vida e mana ao ser consumida mesmo sob condições debilitantes e fornece aumento temporário de dano físico, dano mágico, defesa física e defesa mágica. Apenas uma pode ser armazenada.",
                necessaryLevel: 79,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 10651,
                cast: 3,
                info:
                    "Cria a poção Água Benta nível 3 no inventário que restaura vida e mana ao ser consumida mesmo sob condições debilitantes e fornece aumento temporário de dano físico, dano mágico, defesa física e defesa mágica. Apenas uma pode ser armazenada.",
                necessaryLevel: 83,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 11703,
                cast: 3,
                info:
                    "Cria a poção Água Benta nível 4 no inventário que restaura vida e mana ao ser consumida mesmo sob condições debilitantes e fornece aumento temporário de dano físico, dano mágico, defesa física e defesa mágica. Apenas uma pode ser armazenada.",
                necessaryLevel: 87,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 13028,
                cast: 3,
                info:
                    "Cria a poção Água Benta nível 5 no inventário que restaura vida e mana ao ser consumida mesmo sob condições debilitantes e fornece aumento temporário de dano físico, dano mágico, defesa física e defesa mágica. Apenas uma pode ser armazenada.",
                necessaryLevel: 91,
            },
            {
                level: 6,
                cooldown: 180,
                mp: 14487,
                cast: 3,
                info:
                    "Cria a poção Água Benta nível 6 no inventário que restaura vida e mana ao ser consumida mesmo sob condições debilitantes e fornece aumento temporário de dano físico, dano mágico, defesa física e defesa mágica. Apenas uma pode ser armazenada.",
                necessaryLevel: 95,
            },
            {
                level: 7,
                cooldown: 180,
                mp: 16311,
                cast: 3,
                info:
                    "Cria a poção Água Benta nível 7 no inventário que restaura vida e mana ao ser consumida mesmo sob condições debilitantes e fornece aumento temporário de dano físico, dano mágico, defesa física e defesa mágica. Apenas uma pode ser armazenada.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 27,
        name: "Flores da Glória",
        levelsInfo: [
            {
                level: 1,
                cooldown: 60,
                mp: 2869,
                cast: 0,
                info:
                    "Envolve todos os membros do grupo em um raio de 20 metros com a flor sagrada que aumenta o efeito de cura em 20% e recupera 580 HP por segundo durante 10 segundos.",
                necessaryLevel: 79,
            },
            {
                level: 2,
                cooldown: 60,
                mp: 3154,
                cast: 0,
                info:
                    "Envolve todos os membros do grupo em um raio de 20 metros com a flor sagrada que aumenta o efeito de cura em 22% e recupera 637 HP por segundo durante 10 segundos.",
                necessaryLevel: 83,
            },
            {
                level: 3,
                cooldown: 60,
                mp: 3466,
                cast: 0,
                info:
                    "Envolve todos os membros do grupo em um raio de 20 metros com a flor sagrada que aumenta o efeito de cura em 24% e recupera 700 HP por segundo durante 10 segundos.",
                necessaryLevel: 87,
            },
            {
                level: 4,
                cooldown: 60,
                mp: 3806,
                cast: 0,
                info:
                    "Envolve todos os membros do grupo em um raio de 20 metros com a flor sagrada que aumenta o efeito de cura em 26% e recupera 769 HP por segundo durante 10 segundos.",
                necessaryLevel: 91,
            },
            {
                level: 5,
                cooldown: 60,
                mp: 4179,
                cast: 0,
                info:
                    "Envolve todos os membros do grupo em um raio de 20 metros com a flor sagrada que aumenta o efeito de cura em 28% e recupera 844 HP por segundo durante 10 segundos.",
                necessaryLevel: 95,
            },
            {
                level: 6,
                cooldown: 60,
                mp: 4589,
                cast: 0,
                info:
                    "Envolve todos os membros do grupo em um raio de 20 metros com a flor sagrada que aumenta o efeito de cura em 30% e recupera 927 HP por segundo durante 10 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 28,
        name: "Cura Concentrada",
        levelsInfo: [
            {
                level: 1,
                cooldown: 6,
                mp: 1671,
                cast: 0,
                info:
                    "Recupera 2026 da sua vida ou de um aliado e aumenta o nível de cura recebida durante 6 segundos com cura extra o equivalente a 6% da vida máxima.",
                necessaryLevel: 81,
            },
            {
                level: 2,
                cooldown: 6,
                mp: 1836,
                cast: 0,
                info:
                    "Recupera 2226 da sua vida ou de um aliado e aumenta o nível de cura recebida durante 6 segundos com cura extra o equivalente a 7% da vida máxima.",
                necessaryLevel: 85,
            },
            {
                level: 3,
                cooldown: 6,
                mp: 2017,
                cast: 0,
                info:
                    "Recupera 2445 da sua vida ou de um aliado e aumenta o nível de cura recebida durante 6 segundos com cura extra o equivalente a 8% da vida máxima.",
                necessaryLevel: 89,
            },
            {
                level: 4,
                cooldown: 6,
                mp: 2215,
                cast: 0,
                info:
                    "Recupera 2685 da sua vida ou de um aliado e aumenta o nível de cura recebida durante 6 segundos com cura extra o equivalente a 9% da vida máxima.",
                necessaryLevel: 93,
            },
            {
                level: 5,
                cooldown: 6,
                mp: 2433,
                cast: 0,
                info:
                    "Recupera 2949 da sua vida ou de um aliado e aumenta o nível de cura recebida durante 6 segundos com cura extra o equivalente a 10% da vida máxima.",
                necessaryLevel: 97,
            },
            {
                level: 6,
                cooldown: 6,
                mp: 2549,
                info:
                    "Recupera 3090 da sua vida ou de um aliado e aumenta o nível de cura recebida durante 6 segundos com cura extra o equivalente a 12% da vida máxima.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 29,
        name: "Pedra da Alma",
        levelsInfo: [
            {
                level: 1,
                cooldown: 180,
                mp: 8118,
                cast: 0,
                info:
                    "Realiza um pacto que faz com que a alma do aliado seja convertida em uma gema por 5 minutos. Um segundo após morrer a gema será consumida e os aliados voltarão com 30% de vida e mana além de ficarem invulneráveis por 5 segundos.",
                necessaryLevel: 85,
            },
            {
                level: 2,
                cooldown: 180,
                mp: 8918,
                cast: 0,
                info:
                    "Realiza um pacto que faz com que a alma do aliado seja convertida em uma gema por 5 minutos. Um segundo após morrer a gema será consumida e os aliados voltarão com 35% de vida e mana além de ficarem invulneráveis por 5 segundos.",
                necessaryLevel: 89,
            },
            {
                level: 3,
                cooldown: 180,
                mp: 10307,
                cast: 0,
                info:
                    "Realiza um pacto que faz com que a alma do aliado seja convertida em uma gema por 5 minutos. Um segundo após morrer a gema será consumida e os aliados voltarão com 40% de vida e mana além de ficarem invulneráveis por 5 segundos.",
                necessaryLevel: 93,
            },
            {
                level: 4,
                cooldown: 180,
                mp: 11320,
                cast: 0,
                info:
                    "Realiza um pacto que faz com que a alma do aliado seja convertida em uma gema por 5 minutos. Um segundo após morrer a gema será consumida e os aliados voltarão com 45% de vida e mana além de ficarem invulneráveis por 5 segundos.",
                necessaryLevel: 97,
            },
            {
                level: 5,
                cooldown: 180,
                mp: 11862,
                info:
                    "Realiza um pacto que faz com que a alma do aliado seja convertida em uma gema por 5 minutos. Um segundo após morrer a gema será consumida e os aliados voltarão com 50% de vida e mana além de ficarem invulneráveis por 5 segundos.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 30,
        name: "Eden Piedoso",
        levelsInfo: [
            {
                level: 1,
                cooldown: 150,
                mp: 6497,
                cast: 6,
                info:
                    "Purifica todos os alvos atingidos em uma área de 6 metros com luz sagrada que causa 1011 de dano mágico até 5 vezes. Cada ataque remove um benefício do inimigo e aplica 632 de dano mágico adicional.",
                necessaryLevel: 89,
            },
            {
                level: 2,
                cooldown: 150,
                mp: 7307,
                cast: 6,
                info:
                    "Purifica todos os alvos atingidos em uma área de 6 metros com luz sagrada que causa 1122 de dano mágico até 5 vezes. Cada ataque remove um benefício do inimigo e aplica 702 de dano mágico adicional.",
                necessaryLevel: 93,
            },
            {
                level: 3,
                cooldown: 150,
                mp: 8116,
                cast: 6,
                info:
                    "Purifica todos os alvos atingidos em uma área de 6 metros com luz sagrada que causa 1246 de dano mágico até 5 vezes. Cada ataque remove um benefício do inimigo e aplica 779 de dano mágico adicional.",
                necessaryLevel: 97,
            },
            {
                level: 4,
                cooldown: 150,
                mp: 8554,
                cast: 6,
                info:
                    "Purifica todos os alvos atingidos em uma área de 6 metros com luz sagrada que causa 1314 de dano mágico até 5 vezes. Cada ataque remove um benefício do inimigo e aplica 821 de dano mágico adicional.",
                necessaryLevel: 99,
            },
        ],
    },
    {
        logoId: 31,
        name: "Dixit Dominus",
        levelsInfo: [
            {
                level: 1,
                cooldown: 90,
                mp: 3550,
                cast: 0,
                info:
                    "Com energia divina concentrada inflige 3550 de dano mágico em inimigos dentro de 4 metros e atordoa por 1 segundo. Esse dano é aumentado em 200% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 95,
            },
            {
                level: 2,
                cooldown: 90,
                mp: 3941,
                cast: 0,
                info:
                    "Com energia divina concentrada inflige 3941 de dano mágico em inimigos dentro de 4 metros e atordoa por 1 segundo. Esse dano é aumentado em 200% caso os alvos sejam Demônios e Mortos-Vivos.",
                necessaryLevel: 99,
            },
        ],
    },
]
